var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21008_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0C17.3021 0 21.6002 4.29806 21.6002 9.6C21.6002 14.5838 17.8027 18.6802 12.9437 19.1541C12.9719 18.8098 12.9657 18.4635 12.9266 18.12C12.6475 15.6816 10.7255 13.7568 8.28774 13.475V0.757714L8.28294 0.746743C9.42602 0.266057 10.6823 0 12.0002 0Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08705 13.4736V1.36114L7.08225 1.3536C7.46762 1.1232 7.86945 0.920229 8.28294 0.746743L8.28774 0.757714V13.475C10.7255 13.7568 12.6475 15.6816 12.9266 18.12C12.9657 18.4635 12.9719 18.8098 12.9437 19.1541C12.6338 19.1842 12.3184 19.1993 12.0002 19.2C8.66762 19.2 5.73139 17.5022 4.01025 14.9239C4.84476 14.1147 5.92476 13.6046 7.08019 13.4743L7.08705 13.4736Z",
    fill: "#152E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9437 19.1541C12.7435 21.6158 10.8276 23.6743 8.28088 23.9657C5.38374 24.2969 2.76636 22.2171 2.43516 19.32C2.24111 17.6249 2.87196 16.0251 4.01025 14.9239C5.73139 17.5022 8.66762 19.2 12.0002 19.2C12.3184 19.1993 12.6338 19.1842 12.9437 19.1541Z",
    fill: "#1E4480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08705 1.36114V13.4736L7.08019 13.4743C5.92476 13.6046 4.84476 14.1147 4.01025 14.9239C2.99334 13.4002 2.40088 11.5694 2.40088 9.6C2.40088 6.096 4.27768 3.02949 7.08225 1.3536L7.08705 1.36114Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21008_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendle);
export default __webpack_public_path__ + "static/media/PENDLE.33c70e5db910d5716cec6321d83ad036.svg";
export { ForwardRef as ReactComponent };